import { maxWidth600 } from "themes/default/breakpoints"

export const styles = {
  paper: (maxWidth) => (theme) => ({
    p: { xs: 2.5, sm: 3 },
    maxWidth: maxWidth || 600,
    width: "100%",
    borderRadius: 3,
    backgroundColor: theme.palette.background.default,
    position: "relative",
    overflow: "hidden",
    [maxWidth600]: {
      m: 1,
      p: 2,
    },
  }),
  closeButton: (theme) => ({
    position: "absolute",
    top: 12,
    right: 12,
    color: theme.palette.grey?.[500],
  }),
  content: (isAlert) => ({
    p: "0 !important",
    display: "flex",
    flexDirection: "column",
    alignItems: isAlert ? "flex-start" : "center",
    textAlign: isAlert ? "left" : "center",
    overflow: "visible !important",
    overflowX: "visible !important",
    overflowY: "visible !important",
  }),
  header: (isAlert) => ({
    display: "flex",
    flexDirection: isAlert ? "row" : "column",
    alignItems: "center",
    gap: isAlert ? 1.5 : 0,
    mb: isAlert ? 1.5 : 0,
    width: "100%",
  }),
  iconWrapper:
    (iconColor, iconBgColor, isAlert = false) =>
    (theme) => {
      const colors = {
        blueBright: {
          color: theme.palette.primary.blueBright,
          bg: theme.palette.primary.blueBrightBg,
        },
        error: {
          color: theme.palette.error.main,
          bg: theme.palette.danger.secondary,
        },
        warning: {
          color: theme.palette.warning.dark,
          bg: theme.palette.warning.bannerBg,
        },
        success: {
          color: theme.palette.success.dark,
          bg: theme.palette.success.lighter,
        },
        primary: {
          color: isAlert
            ? theme.palette.danger.medium
            : theme.palette.primary.main,
          bg: theme.palette.secondary?.light,
        },
        orange: {
          color: theme.palette.danger.medium,
          bg: theme.palette.secondary?.light,
        },
      }
      const defaultColor = isAlert ? colors.primary : colors.blueBright
      const active = colors[iconColor] || defaultColor

      return {
        width: isAlert ? 48 : 52,
        height: isAlert ? 48 : 52,
        borderRadius: "50%",
        backgroundColor: iconBgColor || active.bg,
        color: active.color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        mb: isAlert ? 0 : 2,
        fontSize: isAlert ? 20 : 24,
      }
    },
  title: (arg) => (theme) => {
    const isAlert = typeof arg === "boolean" && arg

    return {
      mb: isAlert ? 0 : 1,
    }
  },
  description: (isAlert) => (theme) => ({
    mb: 3,
    width: "100%",
    letterSpacing: "0.4px",
  }),
  divider: (theme) => ({
    width: "100%",
    alignSelf: "stretch",
    borderTop: `.5px solid ${theme.palette.grey?.lighter2}`,
  }),
  actions: (isAlert) => ({
    display: "flex",
    flexDirection: "row",
    gap: 1.5,
    width: "100%",
    justifyContent: isAlert ? "flex-end" : "center",
    mt: isAlert ? 2.5 : 0,
  }),
  actionBtn:
    (isAlert, variant = "contained") =>
    (theme) => ({
      borderRadius: 1.5,
      flex: isAlert ? "none" : 1,
      minWidth: isAlert ? 130 : "auto",
      textTransform: "none",
      whiteSpace: "normal",
      wordBreak: "break-word",
      textAlign: "center",
      ...(isAlert &&
        variant === "contained" && {
          backgroundColor: theme.palette.danger.medium,
          color: theme.palette.common.white,
          "&:hover": {
            backgroundColor: theme.palette.danger.medium,
            opacity: 0.9,
          },
        }),
      ...(isAlert &&
        variant === "outlined" && {
          color: theme.palette.text?.primary,
          border: "1px solid",
          borderColor: theme.palette.grey?.lighter2,
          backgroundColor: theme.palette.background?.paper,
          "&:hover": {
            borderColor: theme.palette.text?.secondary,
            backgroundColor: theme.palette.action?.hover,
          },
        }),
    }),
}
